// Client-specific (Kund:innen-Zugang) sentences of the portal-access UI. Everything
// subject-neutral lives in `portalAccess`.
const clientAccess = {
  title: "Kund:innen Zugang",
  description:
    "Verwalten Sie den Zugang der Klient:in zum externen Portal. Nach der Freischaltung kann die Klient:in ihre Daten selbst verwalten.",
  invitation: {
    description:
      "Wählen Sie eine der hinterlegten E-Mail-Adressen. An diese Adresse wird eine Einladungs-E-Mail mit dem Registrierungslink gesendet.",
    emailLabel: "E-Mail-Adresse für Einladung",
    noEmails:
      "Für die Klient:in ist keine E-Mail-Adresse hinterlegt. Ergänzen Sie zuerst eine E-Mail-Adresse in den persönlichen Daten.",
    duplicateTitle: "Zu <email>{{email}}</email> existiert bereits ein Portalaccount.",
    duplicateLinkedTo: "Verknüpft mit:",
    identityDocument: {
      type: "Ausweisart",
      number: "Ausweisnummer",
      issuingAuthority: "Ausstellende Behörde",
      validUntil: "Gültig bis",
    },
  },
  pending: {
    description:
      "Die Einladungs-E-Mail wurde versendet. Sobald die Klient:in den Registrierungslink öffnet und das Formular ausfüllt, gilt die Registrierung als erfolgreich.",
  },
  manage: {
    confirmLockText:
      "Der Login des Portalbenutzers wird gesperrt. Die Verknüpfung zwischen Benutzer und Klient:in bleibt bestehen. Ein Aktenvermerk vom Typ „Systemmeldung“ wird erstellt.",
    confirmUnlockText:
      "Der Login des Portalbenutzers wird wieder freigegeben. Ein Aktenvermerk vom Typ „Systemmeldung“ wird erstellt.",
    confirmResetText:
      "Die Klient:in erhält eine E-Mail an {{email}} mit einem Link zum Setzen eines neuen Passworts. Ein Aktenvermerk vom Typ „Systemmeldung“ wird erstellt.",
  },
};

export default clientAccess;
